module.exports = __webpack_public_path__ + "static/mountain-8e418c32771294da597888fcc9a866a8.jpg";